import styled from 'styled-components';

export const CentreContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const LoggedInBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 1296px;
  width: 90%;
  height: 75vh;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);
  position: relative;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 100%;
    width: 100%;
    margin-top: 0;
    box-shadow: none;
    border-radius: 0px;
    flex-direction: column-reverse;
  }
`;

export const LoggedInResponsiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 15px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin-top: 0;
    box-shadow: none;
    border-radius: 0px;
  }
`;
export const ChildrenContainer = styled.div<{
  vaultIDShowing: boolean;
  isMessages: boolean;
}>`
  width: 100%;
  height: ${(props) =>
    props.vaultIDShowing ? '84%' : props.isMessages ? '89%' : '100%'};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: hidden;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 100%;
  }
`;
export const LoggedInChildren = styled.div<{
  $greyBackground?: boolean;
  $isMenuOpen?: boolean;
}>`
  height: 100%;
  width: calc(100% - ${(props) => (props.$isMenuOpen ? '200px' : '80px')});
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;

  transition: width 0.5s;
  transition-timing-function: cubic-bezier(0, 0.5, 0, 1);

  ${(props) => props.$greyBackground && 'background-color: rgba(0,0,0,0.02);'}

  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 100%;
  }
`;

export const VaultLogoContainer = styled.div`
  max-height: 25px;
  margin-top: 20px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;
